/* eslint-disable max-len */
<template>
  <div id="app">
   <v-app light>
     <Header class="hidden-sm-and-down" />
     <HeaderMobile class="hidden-md-and-up" />
     <!-- <Registration/> -->
  </v-app>
 </div>
</template>

<script>
import Header from '../components/molecules/Header.vue';
import HeaderMobile from '../components/molecules/HeaderMobile.vue';

// import Registration from '../components/molecules/Registration.vue';

export default {
  components: {
    Header,
    HeaderMobile,
   // Registration,
  },
  data: () => ({

  }),
};
</script>

<style>
.parallax img { width: 100%; }
</style>
